import React from 'react';

import { ChevronDownIcon, UserIcon } from '@heroicons/react/24/solid';
import PropTypes from 'prop-types';
import {
    Button,
    ListBox,
    ListBoxItem,
    Popover,
    Select,
} from 'react-aria-components';

import styles from './PassengerSelect.scss';

const PASSENGER_OPTIONS = Array.from({ length: 8 }, (_, i) => `${i + 1}`);

export function PassengerSelect(props) {
    const {
        onChange,
        value = '1',
        rowClass,
    } = props;

    function handleSelectionChange(key) {
        onChange?.(`${key}`);
    }

    return (
        <span className={rowClass}>
            <Select
                aria-label="Passengers"
                className={styles.select}
                onSelectionChange={handleSelectionChange}
                selectedKey={value}
            >
                <Button className={styles.wrapper}>
                    <UserIcon className={styles.icon} />
                    <span className={styles.right}>
                        <span className={styles.value}>{value}</span>
                        Passenger{Number(value) > 1 && 's'}
                        <ChevronDownIcon className={styles.chevron} />
                    </span>
                </Button>
                <Popover className={styles.popover} placement="bottom">
                    <ListBox className={styles.listBox}>
                        {PASSENGER_OPTIONS.map((n) => (
                            <ListBoxItem
                                className={styles.listBoxItem}
                                id={n}
                                key={n}
                            >
                                {n}
                            </ListBoxItem>
                        ))}
                    </ListBox>
                </Popover>
            </Select>
        </span>
    );
}

PassengerSelect.propTypes = {
    onChange: PropTypes.func,
    rowClass: PropTypes.string,
    value: PropTypes.string,
};

export default PassengerSelect;
